import { BnkleLogoFull } from "assets/svg";
import { useRef, useState } from "react";
import {
  TbChevronDown,
  TbChevronUp,
  TbMenu2,
  TbX,
  TbArrowLeft,
} from "react-icons/tb";
import { NavLink, useLocation } from "react-router-dom";
import { links } from "./constant";
import { SolutionsModal } from "./SolutionsModal";
import { AuthButtonsSection } from "./AuthButtonsSection";
import { NavigationLink } from "./NavigationLink";
import { PricingModal } from "./PricingModal";
import { NavigationButton } from "./NavigationButton";
import ApplyForFundingForm from "pages/developers/fundingForm/ApplyForFundingForm";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [pricingOpen, setPricingOpen] = useState(false);
  const [activeMobileMenu, setActiveMobileMenu] = useState<
    "root" | "solutions" | "pricing"
  >("root");

  const solutionsBtnRef = useRef<HTMLButtonElement | null>(null);
  const pricingBtnRef = useRef<HTMLButtonElement | null>(null);
  const { pathname } = useLocation();
  const [openForm, setOpenForm] = useState(false);

  const handleSolutionsToggle = () => {
    setSolutionsOpen((prev) => !prev);
    setPricingOpen(false);
  };

  const handlePricingToggle = () => {
    setPricingOpen((prev) => !prev);
    setSolutionsOpen(false);
  };

  const filteredLinks =
    pathname === "/about-us"
      ? links.filter((link) => link.name !== "Blog")
      : links;

  return (
    <header className="sticky z-20 top-0 bg-white border-b border-pbg">
      <div className="py-3 px-4 md:px-16">
        <nav className=" referral-container">
          <div className="flex justify-between items-center">
            {activeMobileMenu === "root" ? (
              <>
                <NavLink to="/">
                  <img
                    src={BnkleLogoFull}
                    alt="bnkle"
                    className="h-8 w-[120px] md:w-[80px] lg:w-[120px]"
                  />
                </NavLink>

                {/* Desktop Menu */}
                <nav className="hidden md:flex space-x-6">
                  {filteredLinks.map(({ id, name, path }) => {
                    if (name === "Solutions") {
                      return (
                        <div key={id} className="relative">
                          <button
                            ref={solutionsBtnRef}
                            className="flex items-center gap-1 cursor-pointer"
                            onClick={handleSolutionsToggle}
                          >
                            <span className="text-sm md:text-xs lg:text-sm font-medium hover:text-blueShades-5">
                              {name}
                            </span>
                            {solutionsOpen ? (
                              <TbChevronUp size={16} />
                            ) : (
                              <TbChevronDown size={16} />
                            )}
                          </button>

                          {solutionsOpen && (
                            <SolutionsModal
                              onClose={() => setSolutionsOpen(false)}
                              triggerRef={solutionsBtnRef}
                            />
                          )}
                        </div>
                      );
                    }

                    if (name === "Pricing") {
                      return (
                        <div key={id} className="relative">
                          <button
                            ref={pricingBtnRef}
                            className="flex items-center gap-1 cursor-pointer"
                            onClick={handlePricingToggle}
                          >
                            <span className="text-sm md:text-xs lg:text-sm font-medium hover:text-blueShades-5">
                              {name}
                            </span>
                            {pricingOpen ? (
                              <TbChevronUp size={16} color="black" />
                            ) : (
                              <TbChevronDown size={16} color="black" />
                            )}
                          </button>

                          {pricingOpen && (
                            <PricingModal
                              onClose={() => setPricingOpen(false)}
                              triggerRef={pricingBtnRef}
                            />
                          )}
                        </div>
                      );
                    }

                    return <NavigationLink to={path} label={name} key={id} />;
                  })}
                </nav>
                <AuthButtonsSection setOpenForm={setOpenForm} />

                {/* Mobile Menu Toggle */}

                <div className="md:hidden">
                  <button onClick={() => setIsOpen((prev) => !prev)}>
                    {isOpen ? <TbX size={24} /> : <TbMenu2 size={24} />}
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-2 w-full">
                <button
                  onClick={() => setActiveMobileMenu("root")}
                  className="flex items-center gap-2 text-xl text-blueShades-4 font-SatoshiMedium"
                >
                  <TbArrowLeft size={20} color="#AEB4BB" />

                  {activeMobileMenu === "solutions" && "Solutions"}
                  {activeMobileMenu === "pricing" && "Pricing"}
                </button>
              </div>
            )}
          </div>
          {/* Mobile Menu */}
          {isOpen && (
            <div className="flex flex-col gap-8 md:hidden mt-4">
              {activeMobileMenu === "root" && (
                <nav className="flex flex-col gap-8">
                  {filteredLinks.map(({ id, name, path }) => {
                    if (name === "Solutions") {
                      return (
                        <NavigationButton
                          key={id}
                          label={name}
                          onClick={() => setActiveMobileMenu("solutions")}
                        />
                      );
                    }

                    if (name === "Pricing") {
                      return (
                        <NavigationButton
                          key={id}
                          label={name}
                          onClick={() => setActiveMobileMenu("pricing")}
                        />
                      );
                    }

                    return (
                      <NavigationLink
                        to={path}
                        label={name}
                        key={id}
                        onClose={() => setIsOpen(false)}
                      />
                    );
                  })}
                </nav>
              )}

              {activeMobileMenu === "solutions" && (
                <div className="mt-6">
                  <SolutionsModal
                    onClose={() => {
                      setActiveMobileMenu("root");
                      setIsOpen(false);
                    }}
                    triggerRef={solutionsBtnRef}
                  />
                </div>
              )}

              {activeMobileMenu === "pricing" && (
                <div className="mt-6">
                  <PricingModal
                    onClose={() => {
                      setActiveMobileMenu("root");
                      setIsOpen(false);
                    }}
                    triggerRef={pricingBtnRef}
                  />
                </div>
              )}

              <AuthButtonsSection
                displayMode="mobile"
                setOpenForm={setOpenForm}
              />
            </div>
          )}
        </nav>
      </div>
      {openForm && <ApplyForFundingForm closer={() => setOpenForm(false)} />}
    </header>
  );
};
